import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

import { AlertService, StudentService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';

import { Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
@Component({
  selector: 'app-des-marks',
  templateUrl: './des-marks.component.html',
  styleUrls: ['./des-marks.component.css']
})
export class DesMarksComponent implements OnInit {
  @ViewChild('setmarkSwal') private setmarkSwal: SwalComponent;
  @ViewChild('markSwal') private markSwal: SwalComponent;
  @ViewChild('submitSwal') private submitSwal: SwalComponent;
  @ViewChild('successSwal') private successSwal: SwalComponent;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private studentService: StudentService,
    private alertService: AlertService,
    private globals: Globals) { }


  public alertOption: SweetAlertOptions = {};

  isError = false;
  loading = false;
  submitted = false;
  returnUrl: string;
  errorMsg: string;
  students = []
  localData = {};
  authenticationService: any;
  student_id: number
  sub

  ngOnInit() {
    this.student_id = this.route.snapshot.params.stdid;
    this.localData = JSON.parse(localStorage.getItem('currentUser'));
    this.returnUrl = '/';
    this.getStudentsData();
  }

  private getStudentsData() {
    this.submitted = true;
    this.studentService.descriptiveMarks(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'], this.student_id)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.students = data.answer;
            //console.log(this.students)
          } else if (data.code == 1001) {
            this.isError = true;
          }
          else if (data.status == 'COM_TOKEN_ERROR') {
            this.loading = false;
            this.router.navigateByUrl('/login');
          }


        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      );
  }

  status: string
  number

  markss = []
  method(event, question_id, maxmarks) {

    if (event.target.value == '') {
      return
    }
    else if (event.target.value > maxmarks) {
      this.markSwal.show();
      return;
    } else {
      this.markss.push({ "question_id": question_id, "marks": event.target.value });
    }
  }
  public onSubmit() {

    if (this.markss.length == 0) {
      this.submitSwal.show();
      return false;
    } else if (this.markss.length != this.students.length) {
      this.submitSwal.show();
      return false;
    }
    var marks = JSON.stringify(this.markss)
    this.studentService.setDescriptiveMarks(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'], marks, this.student_id,)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.status = data.status
            this.successSwal.show();
            this.router.navigateByUrl('/descriptive');
          }
          else if (data.code == 1001) {
            this.isError = true;
            this.router.navigateByUrl('/descriptive');
          }
          else 
          {
            if (data.status == 'COM_TOKEN_ERROR')
            {
              this.loading = false;
              this.router.navigateByUrl('/login');              
            }

          } 
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      );

  }
pic
  public image(image){
    this.pic=image
  }

  public redirect(url){
    var abc=url
    window.open(abc)
  }

}
